import { AxiosResponse } from 'axios';
import { SET_EMPLOYEE_ALLOWANCES, SET_EMPLOYEE_ALLOWANCE, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_EMPLOYEE_ALLOWANCE_ISLOADING,
  DELETE_EMPLOYEE_ALLOWANCE,
  EDIT_EMPLOYEE_ALLOWANCE,
  GET_EMPLOYEE_ALLOWANCES,
  GET_EMPLOYEE_ALLOWANCE,
  REGISTER_EMPLOYEE_ALLOWANCE,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import EmployeeAllowance from '@/services/employee_allowance';
import { Module } from 'vuex';
import { EditEmployeeAllowance, RegisterEmployeeAllowance, GetEmployeeAllowance } from '@/dtos/employee_allowance.dto';

const employeeAllowance: Module<any, {}> = {
  state: {
    employeeAllowance: {
      data: null,
      isLoading: false,
    },
    employeeAllowances: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    employeeAllowance: (state: { employeeAllowance: any }) => state.employeeAllowance,
    employeeAllowances: (state: { employeeAllowances: any }) => state.employeeAllowances,
  },
  mutations: {
    [SET_EMPLOYEE_ALLOWANCE]: (
      state: { employeeAllowance: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.employeeAllowance.data = payload.data) : null,
        (state.employeeAllowance.isLoading = payload.isLoading);
    },
    [SET_EMPLOYEE_ALLOWANCES]: (
      state: { employeeAllowances: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.employeeAllowances.data = payload.data) : null,
        (state.employeeAllowances.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_EMPLOYEE_ALLOWANCE]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_ALLOWANCE, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeAllowance.registerEmployeeAllowance(
        payload as RegisterEmployeeAllowance
      );

      if (result) {
        if (result.data.status) {
          commit(SET_EMPLOYEE_ALLOWANCE, { data: result.data.data, isLoading: false });
          return result.data.data;
        }
        commit(SET_EMPLOYEE_ALLOWANCE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_ALLOWANCE, { isLoading: false });
        return false;
      }
    },
    [GET_EMPLOYEE_ALLOWANCES]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_ALLOWANCES, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeAllowance.getEmployeeAllowances(
        payload as GetEmployeeAllowance
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_ALLOWANCES, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_ALLOWANCES, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_ALLOWANCES, { isLoading: false });
        return false;
      }
    },
    [GET_EMPLOYEE_ALLOWANCE]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_ALLOWANCE, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeAllowance.getEmployeeAllowances(
        payload as GetEmployeeAllowance
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_ALLOWANCE, { data: result.data.data[0], isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_ALLOWANCE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_ALLOWANCE, { isLoading: false });
        return false;
      }
    },
    [EDIT_EMPLOYEE_ALLOWANCE]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_ALLOWANCE, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeAllowance.editEmployeeAllowance(
        payload as EditEmployeeAllowance
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_ALLOWANCE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_ALLOWANCE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_ALLOWANCE, { isLoading: false });
        return false;
      }
    },
    [DELETE_EMPLOYEE_ALLOWANCE]: async ({ commit }: any, payload: string) => {
      commit(SET_EMPLOYEE_ALLOWANCE, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeeAllowance.deleteEmployeeAllowance(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_ALLOWANCE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_ALLOWANCE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_ALLOWANCE, { isLoading: false });
        return false;
      }
    },
    [CLEAR_EMPLOYEE_ALLOWANCE_ISLOADING]: ({ commit }) => {
      commit(SET_EMPLOYEE_ALLOWANCE, { isLoading: false });
      commit(SET_EMPLOYEE_ALLOWANCES, { isLoading: false });
    },
  },
};

export default employeeAllowance;
